export default __webpack_public_path__ + "static/media/pin.489094d7.svg";